import React from "react";
import Alert from "react-bootstrap/lib/Alert";
import Modal from "react-bootstrap/lib/Modal";
import Button from "react-bootstrap/lib/Button";

export class RoomModal extends React.Component {
    constructor(props) {
        super(props);

        this.editMode = false;
        this.title = 'Add room';

        this.state = {
            formData: this.initialFormData(),
            alertShow: false,
            alertMessage: '',
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    initialFormData() {
    }

    showAlert(message) {
        this.setState((state, props) => ({
            alertShow: true,
            alertMessage: message
        }));
    }

    handleInputChange(event) {
        const target = event.target;
        this.setState((state, props) => {
            const {formData} = {...state};
            formData[target.name] = target.value;
            return {formData}
        });
    }

    handleCheckBoxChange(event, conferenceDay) {
        const {formData} = {...this.state};
        formData.dateCheckBoxes[conferenceDay] = !formData.dateCheckBoxes[conferenceDay];
        this.setState({formData})
    }

    handleClose() {
        // Clean up modal state
        this.setState({
            formData: this.initialFormData(),
            alertShow: false,
            alertMessage: ''
        });

        // Call parent's callback
        this.props.handleClose()
    }

    async handleSave() {
    }

    render() {
        const {conferenceDates, show} = this.props;
        const {formData} = this.state;

        let inputCheckBoxes;
        if (!this.editMode) {
            inputCheckBoxes =
                <div className="modal_duplicateroom" style={{paddingTop: "10px"}}>
                    Assign room to days*
                    <div id="modal_collapserooms">
                        <div className="modal_wellrooms">
                            {conferenceDates.map((conferenceDay, index) =>
                                <span key={index}>
                                    <label>
                                        <input type="checkbox"
                                               checked={formData.dateCheckBoxes[conferenceDay]}
                                               onChange={(e) => this.handleCheckBoxChange(e, conferenceDay)}/>
                                        {"Day " + (index + 1)}
                                    </label>
                                </span>
                            )}
                        </div>
                    </div>
                </div>
        }

        let alert;
        if (this.state.alertShow) {
            alert = <React.Fragment><br/><br/><Alert bsStyle="danger">{this.state.alertMessage}</Alert></React.Fragment>
        }

        return (
            <Modal show={show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span>Room name*</span>
                    <input type="text"
                           className="form-control modal_roominputtext"
                           id="modal_roominputname"
                           name="name"
                           value={this.state.formData.name}
                           onChange={this.handleInputChange}/>
                    <br/>
                    <span>Location</span>
                    <input type="text"
                           className="form-control modal_roominputtext"
                           id="modal_roominputlocation"
                           name="location"
                           value={this.state.formData.location}
                           onChange={this.handleInputChange}/>
                    {!this.editMode && inputCheckBoxes}
                    <br/>
                    <span>(*) Mandatory fields</span>
                    {alert}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.handleClose}>Close</Button>
                    <Button bsStyle="primary" onClick={this.handleSave}>Save changes</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}
